// extracted by mini-css-extract-plugin
export var card = "_7z-0";
export var failedIcon = "_7z-4";
export var failedIconBadge = "_7z-3";
export var icon = "_7z-1";
export var successIcon = "_7z-2";